import { BFFAgent } from 'BFFAgent'
import { put, call } from 'redux-saga/effects'
import {
	TAKING_CAR_PURCHASE_SAVE_BOTH_SUCCESS,
	TAKING_CAR_PURCHASE_SAVE_BOTH_FAILURE
} from '../constants'

export function* saveTakingCarManagementBothSaga(data) {
	const { tcs, tcm } = data.data
	try {
		const responseUpdateStateMachineTcm = yield call(
			BFFAgent.Stock.TakingCarManagement.dispatchAction,
			tcm?.id,
			tcm?.statusId,
			true,
			tcm?.fields)
		const responseUpdateStateMachineTcs = yield call(BFFAgent.Stock.TakingCarManagement.dispatchAction,
			tcs?.id,
			tcs?.statusId,
			true,
			tcs?.fields)
		const responseUpdateStateMachine = { tcm: { ...responseUpdateStateMachineTcm }, tcs: { ...responseUpdateStateMachineTcs }}
		if (responseUpdateStateMachine) {
			yield put({
				type: TAKING_CAR_PURCHASE_SAVE_BOTH_SUCCESS,
				data: responseUpdateStateMachine
			})
		}
	} catch (error) {
		yield put({
			type: TAKING_CAR_PURCHASE_SAVE_BOTH_FAILURE,
			data: { error }
		})
	}
}
